import _slicedToArray from "/home/appuser/diet.simeonsidieet.ee/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import React from 'react';
import { useUuid, useFocusTrap, useScrollLock, useFocusReturn } from '@mantine/hooks';
import { getDefaultZIndex } from '@mantine/styles';
import { CloseButton } from '../ActionIcon/CloseButton/CloseButton.js';
import { Text } from '../Text/Text.js';
import { Paper } from '../Paper/Paper.js';
import { Overlay } from '../Overlay/Overlay.js';
import { Portal } from '../Portal/Portal.js';
import useStyles from './Modal.styles.js';
import { GroupedTransition } from '../Transition/GroupedTransition.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
function MantineModal(_a) {
  var _b = _a,
    className = _b.className,
    opened = _b.opened,
    title = _b.title,
    onClose = _b.onClose,
    children = _b.children,
    _b$hideCloseButton = _b.hideCloseButton,
    hideCloseButton = _b$hideCloseButton === void 0 ? false : _b$hideCloseButton,
    overlayOpacity = _b.overlayOpacity,
    _b$size = _b.size,
    size = _b$size === void 0 ? "md" : _b$size,
    _b$transitionDuration = _b.transitionDuration,
    transitionDuration = _b$transitionDuration === void 0 ? 300 : _b$transitionDuration,
    closeButtonLabel = _b.closeButtonLabel,
    overlayColor = _b.overlayColor,
    _b$overflow = _b.overflow,
    overflow = _b$overflow === void 0 ? "outside" : _b$overflow,
    _b$transition = _b.transition,
    transition = _b$transition === void 0 ? "pop" : _b$transition,
    _b$padding = _b.padding,
    padding = _b$padding === void 0 ? "lg" : _b$padding,
    _b$shadow = _b.shadow,
    shadow = _b$shadow === void 0 ? "lg" : _b$shadow,
    id = _b.id,
    classNames = _b.classNames,
    styles = _b.styles,
    sx = _b.sx,
    _b$closeOnClickOutsid = _b.closeOnClickOutside,
    closeOnClickOutside = _b$closeOnClickOutsid === void 0 ? true : _b$closeOnClickOutsid,
    _b$centered = _b.centered,
    centered = _b$centered === void 0 ? false : _b$centered,
    others = __objRest(_b, ["className", "opened", "title", "onClose", "children", "hideCloseButton", "overlayOpacity", "size", "transitionDuration", "closeButtonLabel", "overlayColor", "overflow", "transition", "padding", "shadow", "id", "classNames", "styles", "sx", "closeOnClickOutside", "centered"]);
  var baseId = useUuid(id);
  var titleId = "".concat(baseId, "-title");
  var bodyId = "".concat(baseId, "-body");
  var _useStyles = useStyles({
      size: size,
      overflow: overflow,
      centered: centered
    }, {
      sx: sx,
      classNames: classNames,
      styles: styles,
      name: "Modal"
    }),
    classes = _useStyles.classes,
    cx = _useStyles.cx,
    theme = _useStyles.theme;
  var focusTrapRef = useFocusTrap(opened);
  var _overlayOpacity = typeof overlayOpacity === "number" ? overlayOpacity : theme.colorScheme === "dark" ? 0.85 : 0.75;
  var _useScrollLock = useScrollLock(),
    _useScrollLock2 = _slicedToArray(_useScrollLock, 2),
    lockScroll = _useScrollLock2[1];
  useFocusReturn({
    opened: opened,
    transitionDuration: transitionDuration
  });
  return /* @__PURE__ */React.createElement(GroupedTransition, {
    onExited: function onExited() {
      return lockScroll(false);
    },
    onEntered: function onEntered() {
      return lockScroll(true);
    },
    mounted: opened,
    transitions: {
      modal: {
        duration: transitionDuration,
        transition: transition
      },
      overlay: {
        duration: transitionDuration / 2,
        transition: "fade",
        timingFunction: "ease"
      }
    }
  }, function (transitionStyles) {
    return /* @__PURE__ */React.createElement("div", __spreadValues({
      className: cx(classes.root, className)
    }, others), closeOnClickOutside && /* @__PURE__ */React.createElement("div", {
      onClick: onClose,
      className: classes.clickOutsideOverlay,
      style: {
        zIndex: 2
      }
    }), /* @__PURE__ */React.createElement("div", {
      className: classes.inner,
      onKeyDownCapture: function onKeyDownCapture(event) {
        var _a2;
        var shouldTrigger = ((_a2 = event.target) == null ? void 0 : _a2.getAttribute("data-mantine-stop-propagation")) !== "true";
        shouldTrigger && event.nativeEvent.code === "Escape" && onClose();
      },
      ref: focusTrapRef
    }, /* @__PURE__ */React.createElement(Paper, {
      className: classes.modal,
      shadow: shadow,
      padding: padding,
      role: "dialog",
      "aria-labelledby": titleId,
      "aria-describedby": bodyId,
      "aria-modal": true,
      tabIndex: -1,
      style: __spreadProps(__spreadValues({}, transitionStyles.modal), {
        marginLeft: "calc(var(--removed-scroll-width, 0px) * -1)",
        zIndex: 3
      })
    }, (title || !hideCloseButton) && /* @__PURE__ */React.createElement("div", {
      className: classes.header
    }, /* @__PURE__ */React.createElement(Text, {
      id: titleId,
      className: classes.title
    }, title), !hideCloseButton && /* @__PURE__ */React.createElement(CloseButton, {
      iconSize: 16,
      onClick: onClose,
      "aria-label": closeButtonLabel
    })), /* @__PURE__ */React.createElement("div", {
      id: bodyId,
      className: classes.body
    }, children))), /* @__PURE__ */React.createElement("div", {
      style: transitionStyles.overlay
    }, /* @__PURE__ */React.createElement(Overlay, {
      zIndex: 0,
      color: overlayColor || (theme.colorScheme === "dark" ? theme.colors.dark[9] : theme.black),
      opacity: _overlayOpacity
    })));
  });
}
function Modal(_c) {
  var _d = _c,
    _d$zIndex = _d.zIndex,
    zIndex = _d$zIndex === void 0 ? getDefaultZIndex("modal") : _d$zIndex,
    props = __objRest(_d, ["zIndex"]);
  return /* @__PURE__ */React.createElement(Portal, {
    zIndex: zIndex
  }, /* @__PURE__ */React.createElement(MantineModal, __spreadValues({}, props)));
}
Modal.displayName = "@mantine/core/Modal";
export { MantineModal, Modal };